/** @file errorText: the one-line text the status bar and toasts show for a failed action. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { Pose3DError } from '@zilo/pose3d-std/errors/pose3DError';

/**
 * `STALE_REV` says someone committed first, `REDO_STALE` that someone committed after the undo; other errors show
 * `CODE: message` (and the hint when there is one).
 */
export function errorText(error: Pose3DError): string {
  if (error.code === ERROR_CODES.STALE_REV) return 'Someone else (an agent?) changed the puppet first; your change was undone. Try again.';
  if (error.code === 'REDO_STALE') return 'Someone else (an agent?) changed the puppet after your undo, so there is nothing to redo.';
  return `${error.code}: ${error.message}${error.hint === undefined ? '' : ` (${error.hint})`}`;
}
